
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {SecurityModule} from "../security/security.module";
import {CurrentVersionComponent} from "./currentVersion.component";

@NgModule({
    declarations: [
        CurrentVersionComponent
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        FlexLayoutModule,
        TranslateModule,
        SecurityModule,
    ],
    providers: [],
    bootstrap: [CurrentVersionComponent]
})
export class CurrentVersionModule { }
